import { topliApi } from '@/shared/api/topli/TopliApi'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { addressListsByPageQueryKey } from '@/entities/Address'

export const deleteAddress = async (addressId: number) => {
  const response = await topliApi.address.delete(addressId)
  return response
}

export const useDeleteAddressApi = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => deleteAddress(id),
    onSettled: async () => {
      queryClient.invalidateQueries({
        queryKey: [addressListsByPageQueryKey],
        refetchType: 'active',
      })
    },
  })
}
